import React from "react";
import { SearchInputComponent } from "../../../../common/components";
import { Stack, Badge } from "@mui/material";
import { CommunicationSearchAndFiltersProps } from "./search-and-filter-type";
import FilterIcon from "../../../../assets/icons/filter-icon.svg";
import "./communication-search-and-filters.scss";

const CommunicationSearchAndFilters: React.FC<
  CommunicationSearchAndFiltersProps
> = ({
  onSearch,
  placeholder = "Search",
  searchRef,
  isReset = false,
  localSearchText,
  onFilterClick,
  appliedFiltersCount = 0,
}) => {
  return (
    <div className="communication-search-and-filters-wrapper search-and-filters-wrapper">
      <div className="search-input-wrapper">
        <SearchInputComponent
          placeholder={placeholder}
          onSearch={onSearch}
          ref={searchRef}
          localSearchText={localSearchText}
        />
      </div>
      <div
        className="communication-icon-filter filter-icon-wrapper"
        onClick={onFilterClick}
        style={{ cursor: "pointer" }}
      >
        <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
          <Badge color="secondary" badgeContent={appliedFiltersCount}>
            <div className="icon-image-and-text">
              <img src={FilterIcon} alt="Filter Icon" />
              Filter
            </div>
          </Badge>
        </Stack>
      </div>
    </div>
  );
};
export default CommunicationSearchAndFilters;
